import { Resource } from './resource';
import { gql } from 'apollo-boost';

export class TimesheetResource extends Resource {
  public static async getData(userId: number, month: number, year: number) {
    return await this.query({
      query: gql`
        query($userId: Int!, $year: Int!, $month: Int!) {
          user(id: $userId) {
            firstName
            lastName
            timetables {
              startDate
              endDate
              timetable {
                monTime
                tueTime
                wedTime
                thuTime
                friTime
                satTime
                sunTime
              }
            }
            card {
              company {
                id
                name
              }
            }
          }
          workdays(userId: $userId, year: $year, month: $month) {
            date
            start
            end
            overtimeAccepted
            overtimeLimit
          }
          dayoffs(acceptedOnly: true, status: true, userId: $userId, year: $year, month: $month) {
            items {
              date
            }
            absence {
              id
              name
              code
              isWorktime
              displayAsWorktime
              isPaid
            }
            hourStart
            minuteStart
            hourEnd
            minuteEnd
          }
          absence {
            id
            name
            code
            isWorktime
            displayAsWorktime
          }
          holidays(year: $year, month: $month) {
            date
          }
        }
      `,
      variables: { userId, year, month }
    });
  }
}
